export class ResponsiveTable {
    /**
     * @type {HTMLElement}
     */
    target = null;


    /**
     * @param {HTMLElement} target
     */
    constructor(target) {
        if (!target) return;
        if (target.querySelector('table') === null) {
            console.warn('ResponsiveTable: No table found.');
            return;
        }
        this.target = target;

        this.setupEventHandler();
    }

    /**
     * Append event handler to buttons.
     *
     * @protected
     * @return void
     */
    setupEventHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.handleAnimation(this.target)
        });
    }

    /**
     * Handle animation on scroll.
     *
     * @param {HTMLElement} container
     */
    handleAnimation(container) {
        const wrapper = container;

        const isScrollable = wrapper.scrollWidth > wrapper.clientWidth;
        if (!isScrollable) return;

        // Calculate threshold with a downward tolerance
        const tableHeight = wrapper.offsetHeight;
        const viewportHeight = window.innerHeight;
        const rawThreshold = viewportHeight / tableHeight;
        const tolerance = 0.1; // Allow 10% less visibility required
        const dynamicThreshold = Math.max(0, Math.min(1, rawThreshold - tolerance));

        const animationScrollDistance = 50;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        wrapper.scrollTo({ left: animationScrollDistance, behavior: "smooth" });
                        setTimeout(() => {
                            wrapper.scrollTo({ left: 0, behavior: "smooth" });
                        }, 500);
                    }, 500);

                    observer.unobserve(wrapper);
                }
            },
            {
                root: null,
                threshold: dynamicThreshold
            }
        );

        observer.observe(wrapper);
    }
}
